import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import uk from "@/i18n/locales/uk.json";

void i18n.use(initReactI18next).init({
	resources: {
		uk: { translation: uk },
	},
	lng: "uk",
	fallbackLng: "uk",
	showSupportNotice: false,
	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
